import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { mangaWorks } from "@/mocks/manga";

const rankStyle = (index: number) => {
  if (index === 0) return "bg-primary-500 text-background-50";
  if (index === 1) return "bg-accent-500 text-background-50";
  if (index === 2) return "bg-secondary-500 text-background-50";
  return "bg-background-200 text-foreground-700";
};

export default function RankingSection() {
  const ranking = [...mangaWorks].sort((a, b) => a.hot - b.hot).slice(0, 8);

  return (
    <section id="ranking" className="scroll-mt-20 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          title="人气榜单"
          subtitle="本周人气最高的漫画，看看大家都在追什么"
          moreLink="/category/all"
          moreText="榜单"
        />
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {ranking.map((work, index) => (
            <Link
              key={work.id}
              to={`/manga/${work.id}`}
              title={`${work.title}漫画免费阅读`}
              className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300/60"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-comic text-base font-bold ${rankStyle(index)}`}
              >
                {index + 1}
              </span>
              <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={work.cover}
                  alt={`${work.title}漫画封面`}
                  title={`${work.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {work.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-600">
                  {work.categoryName} · {work.latestChapter}
                </p>
              </div>
              <div className="shrink-0 text-right">
                <p className="flex items-center justify-end gap-1 text-sm font-bold text-accent-700">
                  <i className="ri-star-fill text-accent-500"></i>
                  {work.rating.toFixed(1)}
                </p>
                <p className="mt-0.5 whitespace-nowrap text-[11px] text-foreground-500">{work.views}人气</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}